import { ObjectivesReference } from '../types'

export type CourseFormSections = 'core' | 'images' | 'syllabus'

/**
 * Determine which sections have changed
 */
export function getDirtySections(
  form: any,
  banner: File | undefined,
  thumbnail: File | undefined,
): CourseFormSections[] {
  // Check Form #1: Core information
  let coreFields = [
    'linkedServiceID',
    'sectionID',
    'title',
    'length',
    'templateID',
  ]
  let coreIsDirty = coreFields.some((fieldName) => {
    let fieldMeta = form.getFieldMeta(fieldName)
    return fieldMeta?.isDirty
  })

  // Check Form #2: Images
  // If a new file is selected, that's a change (regardless of existing image)
  let imagesChanged = !!banner || !!thumbnail

  // Check Form #3: Syllabus
  let syllabusFields = ['description', 'objectives', 'references']
  let syllabusIsDirty = syllabusFields.some((fieldName) => {
    let fieldMeta = form.getFieldMeta(fieldName)
    return fieldMeta?.isDirty
  })

  // Build array functionally without mutations
  return [
    ...(coreIsDirty ? ['core' as CourseFormSections] : []),
    ...(imagesChanged ? ['images' as CourseFormSections] : []),
    ...(syllabusIsDirty ? ['syllabus' as CourseFormSections] : []),
  ]
}

/**
 * Validate specific sections
 */
export function validateSections(
  values: any,
  sections: CourseFormSections[],
): boolean {
  // Validate each section using .every() for functional approach
  return sections.every((section) => {
    if (section === 'core') {
      return (
        values.linkedServiceID &&
        values.sectionID &&
        values.title?.length >= 3 &&
        values.length != null &&
        values.length >= 0 &&
        values.templateID
      )
    }

    if (section === 'images') {
      // Images are optional, always valid if changed
      return true
    }

    if (section === 'syllabus') {
      return (
        values.description &&
        values.objectives?.length >= 0 &&
        values.objectives.every(
          (obj: ObjectivesReference) => obj.text?.trim() !== '',
        ) &&
        values.references?.length >= 0 &&
        values.references.every(
          (ref: ObjectivesReference) => ref.text.trim() !== '',
        )
      )
    }

    return true
  })
}
